module.exports = __webpack_public_path__ + "static/img/banner_01.6e9153e8.png";